import { Button, Input, Space, Table, Modal, message, Tag, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import Server from "../../../server/Server";
import URL from "../../../server/URL";
import { ExclamationCircleFilled } from '@ant-design/icons';
import ProductMergeEdit from "./ProductMergeEdit";
import EUtils, { IButtonConfig } from "../../../utils/EUtils";
import ESearch, { IMoreConfig, ISearchConfig } from "../../../components/esearch/ESearch";

const { confirm } = Modal;

const ProductMerge = () => {
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState<any>({ pageIndex: 1, pageSize: 50 });
    const [searchValue, setSearchValue] = useState('');
    const [dataSource, setDataSource] = useState<any>([]);
    const [isOpen, setIsOpen] = useState(false);
    const [editRecord, setEditRecord] = useState<any>({});

    const [scrollY, setScrollY] = useState("");
    const resize = () => setScrollY(EUtils.getTableScroll(82, ''));
    //页面加载完成后才能获取到对应的元素及其位置
    useEffect(() => {
        resize();
    }, [dataSource])

    useEffect(() => {
        loadData();
    }, [page])

    const loadData = () => {
        var params = {
            ...page,
            options: refESearch.current?.getOptions()
        };
        Server.Post(URL.ProductMerge.GetProductMergeList, params).then((response: any) => {
            if (response.isSuccess) {
                setDataSource(response.data);
                setTotal(response.total);
            }
        })
    }

    const showDeleteConfirm = (record: any) => {
        confirm({
            title: '删除产品库',
            icon: <ExclamationCircleFilled />,
            content: '产品库编码[' + record.code + ']，确认要删除，一旦删除将不能恢复，请慎重操作',
            okText: '确定',
            cancelText: '取消',
            onOk() {
                var param = { productMergeID: record.productMergeID }
                Server.Post(URL.ProductMerge.DeleteProductMerge, param).then((response: any) => {
                    if (response.isSuccess) {
                        loadData();
                        message.success('删除成功!');
                    }
                })
            },
            onCancel() {
            },
        });
    };

    const columns: any[] = [
        {
            key: 'name', title: '产品名称', dataIndex: 'name', fixed: 'left', width: 150,
            ellipsis: true,
            render: (text: any, record: any) => <a onClick={() => {
                setEditRecord({
                    viewMode: 1,
                    productMergeID: record.productMergeID
                });
                setIsOpen(true)
            }}>{text}</a>
        },
        { title: '产品类型', dataIndex: 'type', ellipsis: true, width: 150 },
        { title: '禁保区域', dataIndex: 'unInsuredArea', ellipsis: true, width: 150 },
        {
            title: '启用状态', dataIndex: 'isActive', ellipsis: true, width: 100, align: 'center',
            render: (text: any) => {
                return text ? <Tag color="green">启用</Tag> : <Tag color="red">禁用</Tag>
            }
        },
        {
            title: '报价表', dataIndex: 'priceAttachment', ellipsis: true, width: 150, align: 'center',
            render(value: any, record: any, index: any) {
                return value ? <a onClick={() => { handleDownload(record.priceAttachment); }}>点击下载</a> : '未上传';
            }
        },
        {
            title: '投保单', dataIndex: 'insuranceAttachment', ellipsis: true, width: 100, align: 'center',
            render(value: any, record: any, index: any) {
                return value ? <a onClick={() => { handleDownload(record.insuranceAttachment); }}>点击下载</a> : '未上传';
            }
        },
        {
            title: '保单样板', dataIndex: 'orderAttachment', ellipsis: true, width: 100, align: 'center',
            render(value: any, record: any, index: any) {
                return value ? <a onClick={() => { handleDownload(record.orderAttachment); }}>点击下载</a> : '未上传';
            }
        },
        { title: '备注', dataIndex: 'remark', ellipsis: true, width: 180 },
        {
            title: '操作', align: 'center', width: 80, fixed: 'right', ellipsis: true,
            render(value: any, record: any, index: any) {
                var configs: IButtonConfig[] = [
                    { name: '下载报价表', onClick: () => { handleDownload(record.priceAttachment); }, hidden: !record.priceAttachment, },
                    { name: '下载投保单', onClick: () => { handleDownload(record.insuranceAttachment); }, hidden: !record.insuranceAttachment, },
                    { name: '下载保单样板', onClick: () => { handleDownload(record.orderAttachment); }, hidden: !record.orderAttachment, },
                    {
                        name: '编辑', onClick: () => {
                            setEditRecord({
                                viewMode: 1,
                                productMergeID: record.productMergeID
                            });
                            setIsOpen(true)
                        }
                    },
                    { name: '删除', onClick: () => { showDeleteConfirm(record); }, hidden: record.isActive, danger: true },
                    { name: '启用', onClick: () => { showActiveConfirm(record); }, hidden: record.isActive },
                    { name: '禁用', onClick: () => { showActiveConfirm(record); }, hidden: !record.isActive, danger: true },
                ];
                return EUtils.InitButtons(configs);
            }
        }];

    const handleDownload = (value: any) => {
        var request = {
            fileInfo: value,
        };
        var fileInfo = JSON.parse(value);
        var orgName = fileInfo.orgName ?? fileInfo.OrgName;
        Server.DownLoad(URL.Common.HttpDownLoadFile, request)
            .then((response: any) => {
                EUtils.DownLoadFile(response.data, orgName);
            })
    };

    const showActiveConfirm = (record: any) => {
        confirm({
            title: record.isActive ? '禁用产品库' : '启用产品库',
            icon: <ExclamationCircleFilled />,
            content: '产品库[' + record.name + ']，确认要' + (record.isActive ? '禁用' : '启用'),
            okText: '确定',
            cancelText: '取消',
            onOk() {
                var param = {
                    productMergeID: record.productMergeID,
                    isActive: !record.isActive
                }
                Server.Post(URL.ProductMerge.ActiveProductMerge, param).then((response: any) => {
                    if (response.isSuccess) {
                        message.success((record.isActive ? '禁用' : '启用') + '成功!');
                        loadData();
                    } else {
                        message.warn(response.returnMsg);
                    }
                })
            },
            onCancel() {
            },
        });
    };

    const refESearch = useRef<any>(null);
    const searchConfig: ISearchConfig[] = [
        { filedID: 'Name', filedName: '产品名称' },
        { filedID: 'Type', filedName: '产品类型' },
        { filedID: 'UnInsuredArea', filedName: '禁保区域' },
        { filedID: 'Remark', filedName: '备注' },
    ];
    const moreConfig: IMoreConfig[] = [
        { type: 'select', filedID: 'IsActive', title: '启用状态', data: [{ value: true, label: '启用' }, { value: false, label: '禁用' }] }
    ];

    return <div>
        <ESearch searchConfig={searchConfig} moreConfig={moreConfig} onLoad={loadData} resize={resize} ref={refESearch} />
        <div>
            <div style={{ backgroundColor: '#fafafa', border: '1px solid #e7e7eb', borderBottom: 'none', height: '45px', padding: '5px' }}>
                <span style={{ lineHeight: '30px', margin: '5px', fontWeight: 'bold' }}></span>
                <Space style={{ float: 'right' }}>
                    <Button type="primary" onClick={() => {
                        setEditRecord({
                            viewMode: 0,
                            productMergeID: null
                        });
                        setIsOpen(true)
                    }}>新增</Button>
                </Space>
            </div>
            <Table size="small"
                bordered
                columns={columns}
                scroll={dataSource.length > 0 ? { x: 'max-content', y: scrollY } : { x: 'max-content' }}
                dataSource={dataSource} pagination={{
                    position: ['bottomRight'],
                    style: { margin: '5px' },
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: total,
                    showTotal: ((total) => {
                        return "共" + total + "条";
                    }),
                    current: page.pageIndex,
                    defaultCurrent: 20,
                    pageSize: page.pageSize,
                    pageSizeOptions: [10, 20, 50, 100, 200],
                    onShowSizeChange: ((page, pageSize) => {
                        setPage({
                            pageIndex: page,
                            pageSize: pageSize
                        });
                    }),
                    onChange: ((page, pageSize) => {
                        setPage({
                            pageIndex: page,
                            pageSize: pageSize
                        });
                    })
                }}
                summary={(pageData) => {
                    return <Table.Summary fixed>
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={1} >
                                <Typography.Text>合计:{dataSource.length}</Typography.Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} colSpan={7} align={'center'}>
                                <Typography.Text></Typography.Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={2} align={'center'}></Table.Summary.Cell>
                        </Table.Summary.Row>
                    </Table.Summary>
                }} />
        </div>
        <ProductMergeEdit isOpen={isOpen} setIsOpen={() => setIsOpen(false)} loadData={loadData} {...editRecord} />
    </div>
}
export default ProductMerge;